import styled from 'styled-components';

export const MenuItemWrapper = styled.div`
/* Base */
.submenu-container {
  position: relative;
  width: 100%;
}

.menu-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle-icon {
  cursor: pointer;
  padding: 8px;
  transition: transform 0.2s ease;
}

.toggle-icon.open {
  transform: rotate(90deg);
}

/* Submenu */
.submenu {
  display: block;
}

/* 📱 Mobile (accordion style) */
@media (max-width: 768px) {
  .submenu {
    position: static;
    width: 100%;
    padding-left: 25px;
  }
  #prefix{
    margin-top: 0.5rem;
  }
  #menu-wrap{
    display: flex;
  }
}

/* 💻 Desktop (hover side menu) */
@media (min-width: 769px) {
  .submenu {
    position: absolute;
    top: 0;
    left: 100%;
    min-width: 220px;
    background: white;
    border: 1px solid rgba(0,0,0,0.15);
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.175);
    z-index: 1000;
  }
  #prefix{
      display: none;
  }
}
`;
